import React, { Component } from "react";
import { DKLabel, DKButton, DKIcons, DKIcon } from "deskera-ui-library";
import Utility from "../../utility/Utility";

/*
PROPS
- style
- className
- directLink
- embedCode
- onClose
*/

class SharePopup extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div
        className={
          "position-absolute pt-s pb-xl p-h-l shadow-l bg-white border-radius-s border-m mobile-width-auto " +
          this.props.className
        }
        style={{...this.props.style }}
      >
        <div className="row justify-content-between">
          <DKLabel text="Share" className="fw-m" />
          <DKButton icon={DKIcons.ic_close} onClick={this.props.onClose} />
        </div>
        {this.props.embedCode && this.getEmbedCodeSection()}
        {this.props.directLink && this.getDirectLinkSection()}
      </div>
    );
  }

  getEmbedCodeSection() {
    return (
      <div className="mt-r mb-xl">
        <DKLabel text="< > Embed code" className="fw-m" />
        <DKLabel
          text="Integrate this code to your website page"
          className="text-dark-gray mt-xs ml-xl"
        />
        <div className="p-s bg-gray1 border-s border-radius-s mt-m row justify-content-between">
          <div className="text-align-left word-wrap-all fs-r text-gray">
            {this.props.embedCode}
          </div>
          <DKButton
            title="Copy"
            className="text-white bg-app ml-r"
            onClick={() => Utility.copyToClipBoard(this.props.embedCode)}
          />
        </div>
      </div>
    );
  }
  getDirectLinkSection() {
    return (
      <div className="mt-r">
        <div className="row">
          <DKIcon src={DKIcons.data_type.ic_url} className="ic-s" />
          <DKLabel text="Direct link" className="fw-m ml-s" />
        </div>
        <DKLabel
          text="Share this link with anyone to view"
          className="text-dark-gray mt-xs ml-xl"
        />
        <div className="p-s bg-gray1 border-s border-radius-s mt-m row justify-content-between">
          <div className="text-align-left word-wrap-all fs-r text-gray">
            {this.props.directLink}
          </div>
          <DKButton
            title="Copy"
            className="text-white bg-app ml-r"
            onClick={() => Utility.copyToClipBoard(this.props.directLink)}
          />
        </div>
      </div>
    );
  }
}

export default SharePopup;
